import type { ReactNode } from 'react';

/**
 * Le « feuillet » — le conteneur de tout contenu.
 *
 * Fond crème, bord supérieur épais qui évoque la reliure d'un registre. Tous
 * les écrans y déposent leur contenu : c'est ce qui donne à l'application son
 * unité, et ce qui permet d'en changer l'aspect d'un seul endroit.
 */
export function Sheet({
  titre,
  action,
  children,
}: {
  titre?: string;
  /** Bouton ou lien aligné à droite du titre. */
  action?: ReactNode;
  children: ReactNode;
}): ReactNode {
  return (
    <section className="sheet">
      {titre !== undefined && (
        <header className="sheet-entete">
          <p className="sheet-title">{titre}</p>
          {action}
        </header>
      )}
      {children}
    </section>
  );
}
